export default "__VITE_ASSET__CY2bp73G__"